import React, { useState } from 'react';
import './VirtualCFO.css';

function PayrollHR() {
  const [activeIndex, setActiveIndex] = useState(null);

  const offerings = [
    {
      title: 'Payroll Management',
      content: [
        'Monthly payroll processing with salary structuring',
        'Automated TDS calculations and payslip generation',
        'Leave, bonus, and arrears calculation',
        'Payroll reconciliation and reporting'
      ]
    },
    {
      title: 'Statutory Compliance',
      content: [
        'EPF, ESI, and PT compliance & filings',
        'TDS on salaries and quarterly returns',
        'Labour law registrations and renewals',
        'Form 16 issuance and year-end compliance'
      ]
    },
    {
      title: 'HR Policy & Documentation',
      content: [
        'HR manual and employee handbook drafting',
        'Employment contracts and onboarding docs',
        'Exit formalities and F&F settlement support',
        'Company policy advisory and drafting'
      ]
    },
    {
      title: 'HRMS & Process Support',
      content: [
        'Leave & attendance tracking system',
        'Biometric & payroll system integration',
        'Employee database management',
        'HR helpdesk and support services'
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/payroll_hr_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Payroll & HR Services</h1>
          <p>Streamlined HR processes and compliant payroll management for modern businesses</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Integrated Payroll and Human Resource Solutions</h2>
          <p>Our Payroll & HR services ensure your employee records, payroll cycles, statutory compliance, and benefit plans are handled with accuracy and confidentiality.</p>
          <p>From salary structuring and TDS deductions to PF/ESI calculations, we manage the entire employee lifecycle and HR documentation.</p>
          <p>We assist you in designing compliant policies, tracking leave and attendance, and generating payslips with statutory filings.</p>
          <p>Let our experts handle your backend HR needs while you focus on building a motivated and productive team.</p>
        </div>
      </section>

      {/* Accordion Section */}
      <section className="accordion-section">
        <h2>Our Offerings</h2>
        <div className="accordion-container">
          {offerings.map((item, index) => (
            <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
              <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                <span>{activeIndex === index ? '−' : '+'}</span> {item.title}
              </div>
              {activeIndex === index && (
                <div className="accordion-body">
                  <ul>
                    {item.content.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default PayrollHR;


